import { useMemo } from 'react';

import { getActiveLtlIntegration } from 'hooks/useCustomers';
import { useServiceFeatures } from 'hooks/useServiceContext';
import { Maybe } from 'types/UtilityTypes';
import { IntegrationType, TMS } from 'types/enums/Integrations';

export function useIntegrationId(): Maybe<number> {
  const { ltlTMSIntegrations, quotingIntegrations } = useServiceFeatures();

  return useMemo(() => {
    const activeLtl = getActiveLtlIntegration(ltlTMSIntegrations);
    if (activeLtl?.name !== TMS.ThreeG) {
      return null;
    }

    const pricingIntegration = quotingIntegrations?.find(
      (i) => i.type === IntegrationType.Quoting && i.name === activeLtl?.name
    );

    return pricingIntegration?.id ?? activeLtl?.id ?? null;
  }, [ltlTMSIntegrations, quotingIntegrations]);
}
